"use client";

import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const categories = [{
  name: "ADULTOS Y FAMILIAS",
  target: "#adultos-familias"
}, {
  name: "JÓVENES",
  target: "#jovenes"
}, {
  name: "NIÑOS",
  target: "#ninos"
}, {
  name: "LÍDERES Y MINISTROS",
  target: "#lideres-ministros"
}, {
  name: "EDUCACIÓN",
  target: "#educacion"
}];
export default function CategoryFilter() {
  return <section id="categoryfilterbar" data-nav="light" className="w-full bg-background py-4 md:py-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center">
          <div className="w-full overflow-x-auto pb-2 pt-1 scrollbar-none md:overflow-visible md:pb-0 md:pt-0">
            <nav aria-label="Filtro de categorías" className="mx-auto flex min-w-max items-center justify-center gap-1.5 rounded-full bg-foreground p-1.5 shadow-md md:gap-2 md:p-2">
              {categories.map((category, i) => <div key={category.target} data-index={i}>
                  <motion.div whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }}>
                    <Button asChild variant="ghost" size="sm" className="h-10 rounded-full px-4 text-xs font-semibold tracking-wider text-background hover:bg-background/15 hover:text-background focus-visible:ring-background/40 md:h-11 md:px-6 md:text-sm">
                      <Link to={category.target}>
                        {category.name}
                      </Link>
                    </Button>
                  </motion.div>
                </div>)}
            </nav>
          </div>
        </div>
      </div>
    </section>;
}